import { createRoutine, promisifyRoutine } from "redux-saga-routines";
import { handleActions } from "redux-actions";

export const PAYMENT_INVOICES_DEFAULT_LIMIT = 10;

export const fetchPaymentInvoicesRoutine = createRoutine(
  "app/paymentInvoices/FETCH_PAYMENT_INVOICES"
);

export const createPaymentInvoiceRoutine = createRoutine(
  "app/paymentInvoices/CREATE_PAYMENT_INVOICE"
);
export const createPaymentInvoicePromiseCreator = promisifyRoutine(
  createPaymentInvoiceRoutine
);

const initialState = {
  loading: false,
  loadingMore: false,
  error: null,
  data: {
    count: 0,
    next: null,
    previous: null,
    results: []
  }
};

export default handleActions(
  {
    [fetchPaymentInvoicesRoutine.TRIGGER]: (state, { payload }) => ({
      ...state,
      loading: payload?.silent || payload?.append ? state.loading : true,
      loadingMore: payload?.silent ? false : !!payload?.append,
      error: null
    }),
    [fetchPaymentInvoicesRoutine.SUCCESS]: (state, { payload }) => ({
      ...state,
      loading: false,
      loadingMore: false,
      error: null,
      data: {
        count: payload?.count ?? 0,
        next: payload?.next ?? null,
        previous: payload?.previous ?? null,
        results: payload?.append
          ? [...state.data.results, ...(payload?.results ?? [])]
          : payload?.results ?? []
      }
    }),
    [fetchPaymentInvoicesRoutine.FAILURE]: (state, { payload }) => ({
      ...state,
      loading: false,
      loadingMore: false,
      error: payload
    })
  },
  initialState
);
